/** @format */

import React from 'react'
import { IconProps } from './index'

const ZoomOut: React.FC<IconProps> = ({
  className,
  width = 14,
  height = 14,
  color = '#848f9a'
}) => {
  return (
    <svg
      className={`icon ${className}`}
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="7850"
    >
      <path
        // eslint-disable-next-line max-len
        d="M919.264 905.984l-138.912-138.912C851.808 692.32 896 591.328 896 480c0-229.376-186.624-416-416-416S64 250.624 64 480s186.624 416 416 416c95.008 0 182.432-32.384 252.544-86.208l141.44 141.44a31.904 31.904 0 0 0 45.248 0 32 32 0 0 0 0.032-45.248zM128 480C128 285.92 285.92 128 480 128s352 157.92 352 352-157.92 352-352 352S128 674.08 128 480z"
        p-id="7851"
      ></path>
      <path d="M625.792 448H336a32 32 0 0 0 0 64h289.792a32 32 0 1 0 0-64z" p-id="7852"></path>
    </svg>
  )
}

export default ZoomOut
